"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationDto = void 0;
const AppVersionDto_1 = require("../app-versions/AppVersionDto");
class LocationDto {
    constructor(params) {
        this.name = "";
        this.mainAddress = "";
        this.aboutUsImageFileName = "";
        this.aboutUsImageContentType = "";
        this.aboutUsImageFileSize = "";
        this.aboutUsImageUpdatedAt = "";
        this.customImageFileName = "";
        this.customImageContentType = "";
        this.customImageFileSize = "";
        this.customImageUpdatedAt = "";
        this.appointmentConfirmationText = "";
        this.defaultLocation = false;
        this.inventoryOverrideUrl = "";
        this.newSalesInventoryFallback = "";
        this.usedSalesInventoryFallback = "";
        this.inventorySearchOptions = "";
        this.inventoryLabelFormat = "";
        this.backgroundStyle = "";
        this.tintColor = "";
        this.buttonTheme = "";
        this.overrideManufacturerRoadsideNumbers = false;
        this.initialScreen = "";
        this.cellBackgroundStyle = "";
        this.slogan = "";
        this.mainPhone = "";
        this.mainEmail = "";
        this.mainEmailFormat = "";
        this.replyToAddress = "";
        this.websiteUrl = "";
        this.websiteFieldText = "";
        this.maxPriceInterval = "";
        this.mileageTextOverride = "";
        this.currencySymbol = "";
        this.vehicleHistoryReportUrl = "";
        this.vehicleRequestFlag = "";
        this.offerlogixId = "";
        this.hideVinFromDisplay = "";
        this.mainButtonOrder = "";
        this.phoneFieldText = "";
        this.messageFieldText = "";
        this.serviceFieldText = "";
        this.roadsideFieldText = "";
        this.rewardsFieldTextOverride = "";
        this.aboutText = "";
        this.showNavBarInHomeScreen = false;
        this.appointmentMakes = "";
        this.inventoryId = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.parentLocationId = params.parentLocationId;
        this.appVersionId = params.appVersionId;
        this.name = params.name;
        this.mainAddress = params.mainAddress;
        this.aboutUsImageFileName = params.aboutUsImageFileName;
        this.aboutUsImageContentType = params.aboutUsImageContentType;
        this.aboutUsImageFileSize = params.aboutUsImageFileSize;
        this.aboutUsImageUpdatedAt = params.aboutUsImageUpdatedAt;
        this.customImageFileName = params.customImageFileName;
        this.customImageContentType = params.customImageContentType;
        this.customImageFileSize = params.customImageFileSize;
        this.customImageUpdatedAt = params.customImageUpdatedAt;
        this.appointmentConfirmationText = params.appointmentConfirmationText;
        this.defaultLocation = params.defaultLocation;
        this.inventoryOverrideUrl = params.inventoryOverrideUrl;
        this.newSalesInventoryFallback = params.newSalesInventoryFallback;
        this.usedSalesInventoryFallback = params.usedSalesInventoryFallback;
        this.inventorySearchOptions = params.inventorySearchOptions;
        this.inventoryLabelFormat = params.inventoryLabelFormat;
        this.backgroundStyle = params.backgroundStyle;
        this.tintColor = params.tintColor;
        this.buttonTheme = params.buttonTheme;
        this.overrideManufacturerRoadsideNumbers = params.overrideManufacturerRoadsideNumbers;
        this.initialScreen = params.initialScreen;
        this.cellBackgroundStyle = params.cellBackgroundStyle;
        this.slogan = params.slogan;
        this.mainPhone = params.mainPhone;
        this.mainEmail = params.mainEmail;
        this.mainEmailFormat = params.mainEmailFormat;
        this.replyToAddress = params.replyToAddress;
        this.websiteUrl = params.websiteUrl;
        this.websiteFieldText = params.websiteFieldText;
        this.maxPriceInterval = params.maxPriceInterval;
        this.mileageTextOverride = params.mileageTextOverride;
        this.currencySymbol = params.currencySymbol;
        this.vehicleHistoryReportUrl = params.vehicleHistoryReportUrl;
        this.vehicleRequestFlag = params.vehicleRequestFlag;
        this.offerlogixId = params.offerlogixId;
        this.hideVinFromDisplay = params.hideVinFromDisplay;
        this.mainButtonOrder = params.mainButtonOrder;
        this.phoneFieldText = params.phoneFieldText;
        this.messageFieldText = params.messageFieldText;
        this.serviceFieldText = params.serviceFieldText;
        this.roadsideFieldText = params.roadsideFieldText;
        this.rewardsFieldTextOverride = params.rewardsFieldTextOverride;
        this.aboutText = params.aboutText;
        this.loanCalculatorTerms = params.loanCalculatorTerms;
        this.showNavBarInHomeScreen = params.showNavBarInHomeScreen;
        this.appointmentMakes = params.appointmentMakes;
        this.inventoryId = params.inventoryId;
        this.latitude = params.latitude;
        this.longitude = params.longitude;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.appVersion !== undefined) {
            this.appVersion = params.appVersion === null ?
                null :
                new AppVersionDto_1.AppVersionDto(params.appVersion);
        }
    }
}
exports.LocationDto = LocationDto;
//# sourceMappingURL=LocationDto.js.map